export default "<div class=\"survey-container\">\n  <div #surveyContent id=\"surveyElement\"></div>\n</div>";